import { svc_cloneCategory, svc_publishCategory, svc_reorderCategories } from "@/services/category";
import { svc_search, svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";

const apiPrefix = "categories";

const Model = {
	namespace: "m_Category",
	state: {
		categories: [],
		category: {}
	},
	reducers: {
		handleFetch(state, { payload: { categories } }) {
			logger(`** Category reducers response ${JSON.stringify(categories)}`, 5);
			return { ...state, categories };
		},
		handleFetchOne(state, { payload: { category } }) {
			logger(`** Category reducers response ${JSON.stringify(category)}`, 5);
			return { ...state, category };
		},
	},
	effects: {
		*fetchCategories({ payload, saveToState = true }, { call, put }) {
			if (payload) {
				if (!payload.brand) {
					return null;
				}
				if (payload.outlet == -1) {
					payload.outlet = null;
				}
                if (!payload.terminal) delete payload.terminal;
			}

			let categories = yield call(svc_search, `${apiPrefix}_custom`, payload);
			_.forEach(categories, function (row) {
				row.key = row.id;
			});

            if (saveToState) {
                yield put({
                    type: "handleFetch",
                    payload: { categories },
                });
            }

			return categories;
		},
		*fetchCategoriesXref({ payload }, { call, put }) {
			if (payload) {
				if (!payload.brand_id) {
					return null;
				} else {
                    payload.brand = payload.brand_id;
                }

				if (payload.outlet_id == -1) {
					payload.outlet = null;
				} else {
                    payload.outlet = payload.outlet_id;
                }

				if (payload.terminal_id == -1) {
					payload.terminal = null;
				} else {
                    payload.terminal = payload.terminal_id;
                }
			}

            payload = _.omit(payload, ["brand_id", "outlet_id", "terminal_id"]);
			let categories = yield call(svc_search, `${apiPrefix}_custom`, payload);
			_.forEach(categories, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetch",
				payload: { categories },
			});

			return categories;
		},
		*fetchOneCategory({ searchKey }, { call, put }) {
			let category = yield call(svc_fetchOne, `${apiPrefix}_custom`, searchKey);
			yield put({
				type: "handleFetchOne",
				payload: { category },
			});
			return category;
		},
		*exportCategory({ payload }, { call, put }) {
			const response = yield call(svc_fetchOne, `${apiPrefix}_custom/export`, payload.id);
			if (response.status === "OK") {
				return JSON.stringify(response.exportedData);
			}
			showServerResponse(response);
		},
		*importCategory({ payload }, { call, put }) {
			const response = yield call(svc_addOne, `${apiPrefix}_custom/import`, payload);
			showServerResponse(response);
			return response;
		},
		*addCategory({ payload }, { call, put }) {
			delete payload.id;
			const response = yield call(svc_addOne, `${apiPrefix}_custom`, payload);
			showServerResponse(response);
			return response;
		},
		*updateCategory({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, apiPrefix, payload, "id", payload.name);
				showServerResponse(response);
				return response;
			}
		},
		*cloneCategory({ payload }, { call, put }) {
			const response = yield call(svc_cloneCategory, payload);
			showServerResponse(response);
			return response;
		},
		*publishCategory({ payload }, { call, put }) {
			const response = yield call(svc_publishCategory, payload);
			showServerResponse(response);
			return response;
		},
		*reorderCategories({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_reorderCategories, payload);
				showServerResponse(response);
				return response;
			}
		},
		*deleteCategory({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_deleteOne, `${apiPrefix}_custom`, payload, "id");
				showServerResponse(response);
				return response;
			}
		},

		*clearCategory({ }, { put }) {
			yield put({
				type: "handleFetchOne",
				payload: { category: {} },
			});
		},
	},
	subscriptions: {
		// setup({ dispatch, history }) {
		// 	return history.listen(({ pathname, query }) => {
		// 		if (pathname === "/menu" || pathname === "/brands") {
		// 			dispatch({ type: "fetchAll", payload: query });
		// 		}
		// 	});
		// },
	},
};

export default Model;
